import LegalLayout, { Section } from "@/components/chalky/LegalLayout"

interface Props {
  last_updated: string
}

const SUPPORT_EMAIL = "hello@chalky.fr"

export default function Support({ last_updated }: Props) {
  return (
    <LegalLayout
      title="Loon Remote"
      titleHighlight="Support"
      subtitle="Loon Remote is a minimal remote for your Behringer X32 monitor (aux) mixes."
      lastUpdated={last_updated}
      lastUpdatedLabel="Last updated:"
      lang="en"
    >
      <Section number="1" title="The app does not find my console">
        <p className="text-slate-400 leading-relaxed">
          The phone and the console must be on the same network; in Settings → Console, enter the console's IP
          address (shown on the console under Setup → Network).
        </p>
      </Section>

      <Section number="2" title="A mix is missing">
        <p className="text-slate-400 leading-relaxed">Turn it on in Settings → Your monitor mixes.</p>
      </Section>

      <Section number="3" title="Anything else">
        <p className="text-slate-400 leading-relaxed">
          Write to{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-slate-200 hover:text-white underline">
            {SUPPORT_EMAIL}
          </a>{" "}
          with your device, its system version and the app version (Settings → About).
        </p>
      </Section>

      <p className="text-sm text-slate-500 leading-relaxed">
        X32 is a trademark of Behringer / Music Tribe. This app is not affiliated with or endorsed by them.
      </p>
    </LegalLayout>
  )
}
